import { render, staticRenderFns } from "./ModifyShop.vue?vue&type=template&id=63840476&scoped=true&"
import script from "./ModifyShop.vue?vue&type=script&lang=ts&"
export * from "./ModifyShop.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyShop.vue?vue&type=style&index=0&id=63840476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63840476",
  null
  
)

export default component.exports